module.exports = __webpack_public_path__ + "assets/hybrid.9afc0b33.svg";